import { MisEntry, MisField } from "../../interfaces/ActionStartResponse";
import { usesDatePicker } from "../../Logic/Mis/misDate";
import MISCheckbox from "./Checkbox";
import MISDateTime from "./DateTimeInput";
import MISDropDownRow from "./DropDown";
import MISMemo from "./Memo";
import MISNumeric from "./Numeric";
import MISTextRow from "./TextBox";
import MISTextWithDropDownRow from "./TextWithDropdown";

export interface MisFieldInputProps {
    field: MisField;
    entry: MisEntry;
    onChange: (entry: MisEntry) => void;
    valid?: boolean;
    setFocus?: boolean;
    /** Show a date-time picker for TextInput fields whose label contains the word "date". */
    enableDatePicker?: boolean;
    firstCol?: number;
}

/** Renders the input for one MIS field type. Display-only types (title, gap, divider) render nothing. */
export default function MisFieldInput(props: MisFieldInputProps) {
    const { field, entry, onChange, valid = true, setFocus, enableDatePicker = false } = props;
    const common = { MisField: field, MisEntry: entry, returnFunc: onChange, Valid: valid, firstCol: props.firstCol };

    switch (field.fieldType) {
        case "Dropdown":
            return (
                <MISDropDownRow
                    {...common}
                    setFocus={setFocus}
                />
            );
        case "TextWithDropdown":
            return <MISTextWithDropDownRow {...common} />;
        case "TextInput":
            return enableDatePicker && usesDatePicker(field, entry.value) ? (
                <MISDateTime {...common} />
            ) : (
                <MISTextRow {...common} />
            );
        case "Memo":
            return <MISMemo {...common} />;
        case "Checkbox":
            return <MISCheckbox {...common} />;
        case "NumericInput":
            return <MISNumeric {...common} />;
        default:
            return null;
    }
}
